import Enumerable from "linq";

export class TabFocusEmulator {
  // Tabキーによるフォーカス移動をエミュレートする
  // アクティブの次のInputタグを返す
  // ルート内の子孫にアクティブが無いと何も起こらない
  // Textareaタグ、Selectタグ、tabindex属性は無視。逆順も非対応
  // ジェネリックは戻りの型が判る場合のみ指定すること
  static emulate<T extends Element>(root: Element, action: (e: T) => void) {
    let foundActive = false;
    TabFocusEmulator.findNextFocus(root, e => {
      if (e === document.activeElement) {
        foundActive = true;
        return false;
      }
      if (!foundActive) {
        return false;
      }
      action(e as T); // 型チェックを入れた方が良い(instanceof T は出来なかった・・・)
      return true;
    });
  }

  private static findNextFocus(node: ChildNode, test: (e: Element) => boolean): boolean {
    const nodes = node.childNodes;
    const array = Enumerable.from(nodes)
      .where(s => s.nodeType === Node.ELEMENT_NODE)
      .select(s => s as Element)
      .toArray();
    for (const item of array) {
      if (item && item.tagName.toUpperCase() === "INPUT") {
        if (test(item)) {
          return true;
        }
      }
      if (this.findNextFocus(item, test)) {
        return true;
      }
    }
    return false;
  }
}
